import { useId } from "react";
import { getPriceBadge } from "@/lib/pricingUtils";

// Fix AT (2026-10-27): "que el precio esté como un círculo, un redondito, algo para que sea más atractivo; mucha
// gente quiere saber cuánto cuesta" (reunión de revisión con el equipo). Sello de precio redondo para las fotos de los
// tratamientos de la página pública. size "lg": grilla de la página principal; "sm": lista de la página de reservas.
// Fix BB (2026-10-30): el sello pasa a ser dorado, con borde ondulado tipo medalla (pedido de la clínica sobre la
// página web: "más dorado" y el sello del precio como la referencia que mandaron). Mismo contenido y mismos tamaños
// de texto; solo cambia la forma y el color. En "sm" crece un poco para que el texto entre dentro del anillo.
const SIZES = {
  lg: { box: "w-[84px] h-[84px] sm:w-24 sm:h-24", qualifier: "text-[9px] sm:text-[10px]", amount: ["text-xl sm:text-2xl", "text-lg sm:text-xl", "text-sm sm:text-base"], struck: "text-[10px] sm:text-[11px]" },
  sm: { box: "w-16 h-16", qualifier: "text-[8px]", amount: ["text-base", "text-sm", "text-xs"], struck: "text-[9px]" },
};

// Borde ondulado: 18 ondas sobre un círculo de radio 46 (viewBox 100x100). Se calcula una sola vez.
const SEAL_PATH = (() => {
  const n = 18;
  const r = 46;
  const chord = 2 * r * Math.sin(Math.PI / n);
  const arc = (chord / 2) * 1.25;
  const pt = (i) => {
    const a = (2 * Math.PI * i) / n - Math.PI / 2;
    return `${(50 + r * Math.cos(a)).toFixed(2)} ${(50 + r * Math.sin(a)).toFixed(2)}`;
  };
  let d = `M ${pt(0)}`;
  for (let i = 1; i <= n; i += 1) d += ` A ${arc.toFixed(2)} ${arc.toFixed(2)} 0 0 1 ${pt(i)}`;
  return `${d} Z`;
})();

export default function PriceBadge({ service, size = "lg", className = "", testId }) {
  const badge = getPriceBadge(service);
  const s = SIZES[size] || SIZES.lg;
  const amountClass = badge.amount.length <= 4 ? s.amount[0] : badge.amount.length <= 6 ? s.amount[1] : s.amount[2];
  const gradientId = `price-seal-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  return (
    <div className={`${s.box} drop-shadow-[0_4px_8px_rgba(41,37,34,0.30)] ${className}`} aria-label={badge.label} data-testid={testId}>
      <div className="relative w-full h-full flex flex-col items-center justify-center text-center text-[#292522] px-2">
        <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" aria-hidden="true" data-seal="gold">
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#F7E8B4" />
              <stop offset="38%" stopColor="#E2C268" />
              <stop offset="72%" stopColor="#C9A13F" />
              <stop offset="100%" stopColor="#EBD48C" />
            </linearGradient>
          </defs>
          <path d={SEAL_PATH} fill={`url(#${gradientId})`} stroke="#A8862F" strokeWidth="1" />
          <circle cx="50" cy="50" r="38" fill="none" stroke="#FFFFFF" strokeOpacity="0.75" strokeWidth="1.2" />
          <circle cx="50" cy="50" r="35.5" fill="none" stroke="#A8862F" strokeOpacity="0.6" strokeWidth="0.6" />
        </svg>
        {badge.qualifier && <span className={`relative ${s.qualifier} font-semibold uppercase tracking-wide leading-none mb-0.5`}>{badge.qualifier}</span>}
        <span className={`relative ${amountClass} font-serif font-bold leading-none`}>{badge.amount}</span>
        {badge.isPromoActive && size === "lg" && <span className={`relative ${s.struck} line-through opacity-70 leading-none mt-1`}>{badge.regularAmount}</span>}
      </div>
    </div>
  );
}
